class NovaPoshtaAPI {
  constructor() {
    this.config = {
      endpoint: 'http://api.novaposhta.ua/v2.0/json/',
      country: 'Ukraine',
      provider: 'Нова пошта'
    };
    
    this.elements = this.initElements();
    this.state = this.initState();
    this.data = {};
    this.debounceTimer = null;
    this.isInitialized = false;
    
    if (!this.elements.bodyNP) {
      console.warn('Nova Poshta widget not found on page');
      return;
    }
    
    // Асинхронна ініціалізація
    this.initialize();
  }

  async initialize() {
    try {
      await this.init();
      this.isInitialized = true;
      console.log('NovaPoshtaAPI successfully initialized');
    } catch (error) {
      console.error('Failed to initialize NovaPoshtaAPI:', error);
      this.isInitialized = false;
      // Очищаємо стан при помилці ініціалізації
      this.cleanup();
    }
  }

  cleanup() {
    this.isInitialized = false;
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = null;
    }
  }

  initElements() {
    const selectors = {
      bodyNP: '#nova-poshta',
      deliveryVariants: '#deliveryVariants',
      deliveryTypes: 'input[type="radio"][name="id"]',
      wrapWarehouse: '.warehouse-wrap',
      wrapAddresses: '.address-wrap',
      listCity: '#city_filter',
      inputCity: '[list="city-search"]',
      listWarehouse: '#warehouse_filter',
      inputWarehouse: '[list="warehouse-search"]',
      inputStreet: '#address-street',
      inputBuild: '#address-build',
      inputFlat: '#address-flat',
      inputFields: '.form-group input',
      filterFields: '.dropdown-filter',
      cityErrorEl: '.city-wrap .input-error',
      warehouseErrorEl: '.warehouse-wrap .input-error',
      streetErrorEl: '.address-wrap .input-error',
      clearCity: '.city-wrap .clear',
      clearWarehouse: '.warehouse-wrap .clear',
      clearStreet: '.form-street .clear',
      checkoutButton: '#CartDrawer button[name="checkout"]',
      deliverySelected: '#CartDrawer .delivery-selected',
      deliveryHeading: '#CartDrawer .delivery-heading'
    };

    const elements = {};
    Object.entries(selectors).forEach(([key, selector]) => {
      if (['deliveryTypes', 'inputFields', 'filterFields'].includes(key)) {
        elements[key] = document.querySelectorAll(selector);
      } else {
        elements[key] = document.querySelector(selector);
      }
    });

    return elements;
  }

  initState() {
    const deliveryTypeRadio = document.querySelector('input[type="radio"][name="id"]:checked');
    
    return {
      deliveryType: deliveryTypeRadio?.getAttribute('data-type') || 'branch',
      widgetStatus: false,
      properties: { _provider: this.config.provider, _country: this.config.country },
      clearProperties: {
        all: this.getAllClearProperties(),
        branch: this.getBranchClearProperties(),
        courier: this.getCourierClearProperties()
      }
    };
  }

  getAllClearProperties() {
    return {
      _delivery_courier_address: ``,
      _delivery_courier_street: ``,
      _delivery_courier_house: ``,
      _delivery_courier_flat: ``,
      _delivery_street_Ref: ``,
      _delivery_city: ``,
      _delivery_city_name: ``,
      _delivery_city_Area: ``,
      _delivery_city_Ref: ``,
      _delivery_warehouse: ``,
      _delivery_warehouse_zip: ``,
      _delivery_warehouse_name: ``,
      _delivery_warehouse_address: ``,
      _delivery_warehouse_CityRef: ``,
      _delivery_warehouse_Number: ``,
      _delivery_warehouse_Ref: ``,
      _delivery_warehouse_SettlementRef: ``,
      _delivery_warehouse_TypeOfWarehouse: ``
    };
  }

  getBranchClearProperties() {
    return {
      _delivery_warehouse: '', _delivery_warehouse_zip: '',
      _delivery_warehouse_name: '', _delivery_warehouse_address: '',
      _delivery_warehouse_CityRef: '', _delivery_warehouse_Number: '',
      _delivery_warehouse_Ref: '', _delivery_warehouse_SettlementRef: '',
      _delivery_warehouse_TypeOfWarehouse: ''
    };
  }

  getCourierClearProperties() {
    return {
      _delivery_courier_street: '', _delivery_courier_house: '',
      _delivery_courier_flat: '', _delivery_street_Ref: ''
    };
  }

  async init() {    
    this.updateCheckoutButtonState();
    await this.validateWidget();
  }

  updateCheckoutButtonState() {
    if (!this.elements) {
      console.warn('NovaPoshtaAPI elements is null, skipping updateCheckoutButtonState');
      return;
    }
    
    const { inputCity, inputWarehouse, inputStreet, checkoutButton, deliverySelected, deliveryHeading } = this.elements;
    
    if (!checkoutButton) return;
    console.log('branch val-', inputWarehouse?.value);
    const isValid = (inputCity?.value?.length > 0 && inputWarehouse?.value?.length > 0) ||
                   (inputCity?.value?.length > 0 && inputStreet?.value?.length > 0);
    
    checkoutButton.classList.toggle('disabled', !isValid);
    checkoutButton.disabled = !isValid;
    if (isValid) {
      this.getDefaultCheckoutText();
      if (inputStreet?.value?.length > 0) {
        deliverySelected.innerHTML = `${inputCity.value},<br> ${inputStreet.value}`;
      } else if (inputWarehouse?.value?.length > 0) {
        deliverySelected.innerHTML = `${inputCity.value},<br> ${inputWarehouse.value}`;
      }
      deliverySelected.hidden = false;
      deliveryHeading.hidden = true;
    } else {
      deliverySelected.hidden = true;
      deliveryHeading.hidden = false;
    }
  }

  getDefaultCheckoutText() {
    const { checkoutButton } = this.elements;
    if (!checkoutButton) return;

    const defaultText = NP.buttonTextCompany;
    this.checkoutButtonText = checkoutButton.querySelector('.btn-text');
    if (defaultText) this.checkoutButtonText.innerHTML = defaultText;
  }

  async fetchAPI(url, data) {
    try {
      const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
      });
      return response.json();
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  }

  async getCartAttributes() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart.attributes || {};
    } catch (error) {
      console.error('Failed to get cart attributes:', error);
      return {};
    }
  }

  async updateCartDeliveryAttr(data) {
    if (!this.state) {
      console.warn('NovaPoshtaAPI state is null, skipping updateCartDeliveryAttr');
      return;
    }
    console.log('NovaPoshtaAPI updateCartDeliveryAttr');
    return this.fetchAPI('/cart/update.js', { attributes: data });
  }  

  async clearCartAttributesNoRedirect() {
    if (!this.state) {
      console.warn('NovaPoshtaAPI state is null, skipping clearCartAttributes');
      return;
    }
    
    // ПРИМІТКА: Додано експериментальний метод clearViaStorefrontAPI() 
    // для дослідження GraphQL Storefront API підходу
    
    console.log('🔄 Starting cart attributes clearing process...');
    
    // Метод 1: Простий XHR метод (найбільш надійний)
    console.log('🔸 Trying Method 1: Simple XHR...');
    try {
      const result = await this.clearViaSimpleXHR();
      console.log('✅ Method 1 SUCCESS: Attributes cleared via simple XHR');
      return result;
    } catch (error) {
      console.error('❌ Method 1 FAILED (Simple XHR):', error.message);
    }

    // Метод 2: Null значення
    console.log('🔸 Trying Method 2: Null values...');
    try {
      const result = await this.clearViaNullValues();
      console.log('✅ Method 2 SUCCESS: Attributes cleared via null values');
      return result;
    } catch (nullError) {
      console.error('❌ Method 2 FAILED (Null values):', nullError.message);
    }
    
    // Метод 3: Fetch з manual redirect
    console.log('🔸 Trying Method 3: Fetch with manual redirect...');
    try {
      const result = await this.clearViaFetchNoRedirect();
      console.log('✅ Method 3 SUCCESS: Attributes cleared via fetch');
      return result;
    } catch (fetchError) {
      console.error('❌ Method 3 FAILED (Fetch):', fetchError.message);
    }
    
    // Метод 4: Очищення через /cart/clear.js (може викликати проблеми)
    console.log('🔸 Trying Method 4: Cart clear method...');
    try {
      const result = await this.clearViaCartClear();
      console.log('✅ Method 4 SUCCESS: Attributes cleared via cart clear');
      return result;
    } catch (clearError) {
      console.error('❌ Method 4 FAILED (Cart clear):', clearError.message);
    }
    
    // Fallback метод
    console.log('🔸 Using FALLBACK method: Standard update...');
    try {
      const result = await this.updateCartDeliveryAttr(this.getAllClearProperties());
      console.log('✅ FALLBACK SUCCESS: Used standard method');
      return result;
    } catch (fallbackError) {
      console.error('❌ ALL METHODS FAILED:', fallbackError.message);
      throw new Error('Unable to clear cart attributes with any method');
    }
  }

  async clearViaSimpleXHR() {
    console.log('🔧 Simple XHR: Using working method pattern...');
    
    // Використовуємо fire-and-forget підхід - без Promise і return
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/update.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          console.log('🔧 Simple XHR: Attributes cleared successfully:', JSON.parse(xhr.responseText));
        } else {
          console.error('🔧 Simple XHR: Failed with status:', xhr.status);
        }
      }
    };
    
    // Використовуємо ту ж структуру атрибутів, що працює
    const clearAttributes = {
      _provider: '',
      _country: null,
      _delivery_courier_address: null,
      _delivery_courier_street: null,
      _delivery_courier_house: null,
      _delivery_courier_flat: null,
      _delivery_street_Ref: null,
      _delivery_city: null,
      _delivery_city_name: null,
      _delivery_city_Area: null,
      _delivery_city_Ref: null,
      _delivery_warehouse: null,
      _delivery_warehouse_zip: null,
      _delivery_warehouse_name: null,
      _delivery_warehouse_address: null,
      _delivery_warehouse_CityRef: null,
      _delivery_warehouse_Number: null,
      _delivery_warehouse_Ref: null,
      _delivery_warehouse_SettlementRef: null,
      _delivery_warehouse_TypeOfWarehouse: null,
      _delivery_type: null
    };
    
    console.log('🔧 Simple XHR: Sending clear attributes with null values');
    xhr.send(JSON.stringify({ attributes: clearAttributes }));
    
    // ВАЖЛИВО: Не повертаємо результат - fire-and-forget для Shopify
  }

  // ЕКСПЕРИМЕНТАЛЬНИЙ МЕТОД: Shopify Storefront API GraphQL
  // Для навчання та дослідження. Потребує додаткових налаштувань.
  async clearViaStorefrontAPI(storefrontAccessToken, checkoutId) {
    console.log('🔧 Storefront API: Using GraphQL checkout attributes...');
    
    // ВАЖЛИВО: Цей метод потребує:
    // 1. Storefront Access Token (з правами на checkout)
    // 2. Checkout ID (отримати через createCheckout mutation)
    // 3. Налаштування CORS на Shopify
    
    if (!storefrontAccessToken || !checkoutId) {
      console.warn('🔧 Storefront API: Missing required parameters (token or checkoutId)');
      return { error: 'Missing storefrontAccessToken or checkoutId' };
    }

    const shopDomain = window.Shopify?.shop || 'your-store.myshopify.com';
    const apiUrl = `https://${shopDomain}/api/2023-10/graphql.json`;

    // Створюємо список атрибутів для очищення
    const clearAttributesKeys = Object.keys(this.getAllClearProperties());
    const customAttributes = clearAttributesKeys.map(key => ({
      key: key,
      value: "" // Порожнє значення для видалення атрибута
    }));

    const mutation = `
      mutation checkoutAttributesUpdate($checkoutId: ID!, $input: CheckoutAttributesUpdateV2Input!) {
        checkoutAttributesUpdateV2(checkoutId: $checkoutId, input: $input) {
          checkout {
            id
            customAttributes {
              key
              value
            }
          }
          checkoutUserErrors {
            code
            field
            message
          }
        }
      }
    `;

    const variables = {
      checkoutId: checkoutId,
      input: {
        customAttributes: customAttributes
      }
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
        },
        body: JSON.stringify({
          query: mutation,
          variables: variables
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      
      if (data.errors) {
        console.error('🔧 Storefront API: GraphQL errors:', data.errors);
        throw new Error(`GraphQL errors: ${JSON.stringify(data.errors)}`);
      }

      if (data.data.checkoutAttributesUpdateV2.checkoutUserErrors.length > 0) {
        console.error('🔧 Storefront API: Checkout errors:', data.data.checkoutAttributesUpdateV2.checkoutUserErrors);
        throw new Error(`Checkout errors: ${JSON.stringify(data.data.checkoutAttributesUpdateV2.checkoutUserErrors)}`);
      }

      console.log('🔧 Storefront API: Attributes cleared successfully:', data.data.checkoutAttributesUpdateV2.checkout);
      return {
        success: true,
        method: 'storefront_api',
        checkout: data.data.checkoutAttributesUpdateV2.checkout
      };

    } catch (error) {
      console.error('🔧 Storefront API: Error:', error);
      throw error;
    }
  }

  
  // ДОДАТКОВИЙ МЕТОД: Отримання checkout ID через Storefront API
  // Для повної реалізації Storefront API підходу
  async createCheckoutForStorefront(storefrontAccessToken, cartItems = []) {
    console.log('🔧 Storefront API: Creating checkout...');
    
    const shopDomain = window.Shopify?.shop || 'your-store.myshopify.com';
    const apiUrl = `https://${shopDomain}/api/2023-10/graphql.json`;

    const mutation = `
      mutation checkoutCreate($input: CheckoutCreateInput!) {
        checkoutCreate(input: $input) {
          checkout {
            id
            webUrl
            customAttributes {
              key
              value
            }
          }
          checkoutUserErrors {
            code
            field
            message
          }
        }
      }
    `;

    // Конвертуємо поточні items кошика в format для GraphQL
    const lineItems = cartItems.map(item => ({
      variantId: `gid://shopify/ProductVariant/${item.variant_id}`,
      quantity: item.quantity
    }));

    const variables = {
      input: {
        lineItems: lineItems,
        customAttributes: []
      }
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
        },
        body: JSON.stringify({
          query: mutation,
          variables: variables
        })
      });

      const data = await response.json();
      
      if (data.errors || data.data.checkoutCreate.checkoutUserErrors.length > 0) {
        throw new Error('Failed to create checkout');
      }

      console.log('🔧 Storefront API: Checkout created:', data.data.checkoutCreate.checkout.id);
      return data.data.checkoutCreate.checkout;

    } catch (error) {
      console.error('🔧 Storefront API: Create checkout error:', error);
      throw error;
    }
  }

  async requestNovaPoshtaAPI(data) {
    try {
      const response = await fetch(this.config.endpoint, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'Content-Type': 'application/json' }
      });
      return response.json();
    } catch (error) {
      console.error('Nova Poshta API Error:', error);
      return null;
    }
  }

  async validateWidget() {
    try {
      const response = await fetch(`https://novaposhta.a.copycon.app/full?shop=${Shopify.shop}`, {
        method: 'GET'
      });
      
      this.state.widgetStatus = response.ok;
      console.log('Widget status -', response.ok);
      
      if (!response.ok) return;
      
      const apiTest = await this.requestNovaPoshtaAPI({
        apiKey: NP.NP_API_KEY,
        modelName: "Address",
        calledMethod: "searchSettlements",
        methodProperties: { CityName: "01001", Limit: "1", Page: "1" }
      });
      
      if (apiTest?.success) {
        this.initMainAPI();
      } else {
        this.handleError('API test failed');
      }
    } catch (error) {
      console.error('Validation error:', error);
    }
  }

  async initMainAPI() {
    try {
      // Перевіряємо чи не був викликаний destroy()
      if (!this.state || !this.elements) {
        console.warn('NovaPoshtaAPI state/elements is null, skipping initialization');
        return;
      }
      
      const cartData = await fetch(`${NP.cartUrl}.json`).then(res => res.json());
      await this.loadCartAttributes(cartData);
      this.bindEvents();
      this.initSearch();
    } catch (error) {
      console.error('Failed to initialize main API:', error);
    }
  }

  async loadCartAttributes(data) {
    // Перевіряємо чи не був викликаний destroy()
    if (!this.state || !this.elements) {
      console.warn('NovaPoshtaAPI state/elements is null, skipping loadCartAttributes');
      return;
    }
    
    console.log('Loading cart attributes, current state:', this.state);
    
    const { wrapWarehouse, wrapAddresses, deliveryVariants } = this.elements;
    
    wrapWarehouse?.classList.add('d-none');
    wrapAddresses?.classList.add('d-none');
    
    // Load existing attributes
    Object.entries(data.attributes || {}).forEach(([key, value]) => {
      if (value && this.state && this.state.properties) {
        this.state.properties[key] = value;
      }
    });

    if (data.attributes?._delivery_type && this.state) {
      this.state.deliveryType = data.attributes._delivery_type;
      this.state.properties._delivery_type = this.state.deliveryType;
      
      deliveryVariants?.setAttribute('data-variant', this.state.deliveryType);
      
      const radioElement = document.querySelector(
        `input[type="radio"][name="id"][data-type="${this.state.deliveryType}"]`
      );
      if (radioElement) radioElement.checked = true;
      
      // Перевіряємо стан перед асинхронним викликом
      if (this.state && this.state.properties) {
        await this.updateCartDeliveryAttr(this.state.properties);
      }
      
      // Перевіряємо стан після асинхронного виклику
      if (this.state && this.state.deliveryType) {
        this.toggleDeliveryMethod(this.state.deliveryType);
      }
    } else if (this.state && this.state.deliveryType) {
      wrapWarehouse?.classList.remove('d-none');
      this.state.properties._delivery_type = this.state.deliveryType;
      
      // Перевіряємо стан перед асинхронним викликом
      if (this.state && this.state.properties) {
        await this.updateCartDeliveryAttr(this.state.properties);
      }
    }
  }

  toggleDeliveryMethod(type) {
    if (!this.elements) {
      console.warn('NovaPoshtaAPI elements is null, skipping toggleDeliveryMethod');
      return;
    }
    
    const { wrapWarehouse, wrapAddresses } = this.elements;
    
    wrapWarehouse?.classList.toggle('d-none', type !== 'branch');
    wrapAddresses?.classList.toggle('d-none', type !== 'courier');
  }

  bindEvents() {
    if (!this.state || !this.elements) {
      console.warn('NovaPoshtaAPI state/elements is null, skipping bindEvents');
      return;
    }
    
    this.bindDeliveryTypeChange();
    this.bindClearButtons();
    this.bindInputs();
    this.bindCheckoutButton();
  }

  bindDeliveryTypeChange() {
    if (!this.state || !this.elements) {
      console.warn('NovaPoshtaAPI state/elements is null, skipping bindDeliveryTypeChange');
      return;
    }
    
    this.elements.deliveryTypes?.forEach(el => {
      el.addEventListener('change', async () => {
        if (!this.state) return; // Перевірка під час виконання        
        
        this.state.deliveryType = el.getAttribute('data-type');
        this.clearAllInputs();
        this.clearErrors();
        console.log('clear all -', this.state.clearProperties.all);

        // Очищаємо атрибути кошика       
        await this.clearViaSimpleXHR();       
        
        this.state.properties._delivery_type = this.state.deliveryType;
        this.state.properties._delivery_method = this.state.deliveryType === 'branch' 
          ? NP.methodBranch 
          : NP.methodCourier;
        
        this.toggleDeliveryMethod(this.state.deliveryType);
        
        await this.updateCartDeliveryAttr(this.state.properties);       
        
        this.updateCheckoutButtonState();
      });
    });
  }

  async clearCartAttributes() {
    console.log('Clearing cart attributes and resetting items...');
    // Зберігаємо поточні товари
    const cart = await fetch('/cart.js').then(res => res.json());
    const items = cart.items;
    
    // Очищаємо кошик повністю
    await fetch('/cart/clear.js', { method: 'POST' });
    
    // Додаємо товари назад без атрибутів
    for (const item of items) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: item.variant_id,
          quantity: item.quantity
        })
      });
    }
  }

  bindClearButtons() {
    document.querySelectorAll('.clear').forEach((el, index) => {
      el.addEventListener('click', async () => {
        await this.handleClearButton(el, index);
      });
    });
  }

  async handleClearButton(element, index) {
    const inputs = document.querySelectorAll('.form-group input');
    if (inputs[index]) {
      inputs[index].value = '';
      inputs[index].readOnly = false;
      inputs[index].focus();
    }
    
    element.classList.add('d-none');
    
    const updateMap = {
      0: this.state.clearProperties.all,
      1: this.state.clearProperties.branch,
      2: this.state.clearProperties.courier
    };
    
    if (updateMap[index]) {
      await this.updateCartDeliveryAttr(updateMap[index]);
    }
    
    if (index === 0) this.clearAllInputs();
    
    this.clearAllFilters();
    this.clearErrors();
    this.elements.bodyNP?.classList.remove('filter-active');
    this.updateCheckoutButtonState();
  }

  bindInputs() {
    this.bindCityInput();
    this.bindWarehouseInput();
    this.bindStreetInput();
    this.bindAddressInputs();
  }

  /* City search and selection */
  bindCityInput() {
    const { inputCity } = this.elements;
    if (!inputCity) return;

    inputCity.addEventListener('keyup', (event) => {
      if (['ArrowLeft', 'ArrowRight'].includes(event.key) || inputCity.readOnly) return;
      
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.handleCitySearch(inputCity.value.trim());
      }, 300);
    });
  }

  async handleCitySearch(searchTerm) {
    const { listCity, cityErrorEl, clearCity } = this.elements;
    
    if (!searchTerm) {
      this.clearList(listCity);
      this.elements.bodyNP?.classList.remove('filter-active');
      clearCity?.classList.add('d-none');
      return;
    }

    clearCity?.classList.remove('d-none');
    
    try {
      const response = await this.requestNovaPoshtaAPI({
        apiKey: NP.NP_API_KEY,
        modelName: "Address",
        calledMethod: "searchSettlements",
        methodProperties: {
          CityName: searchTerm,
          Limit: "150",
          Page: "1",
          Warehouse: "1"
        }
      });

      if (response?.data?.[0]?.Addresses) {
        this.displayCityResults(response.data[0].Addresses);
        if (cityErrorEl) cityErrorEl.innerHTML = '';
      } else {
        if (cityErrorEl) cityErrorEl.innerHTML = NP.alertCity || 'Місто не знайдено';
      }
    } catch (error) {
      console.error('City search error:', error);
      if (cityErrorEl) cityErrorEl.innerHTML = NP.alertKeyboard || 'Помилка пошуку';
    }
  }

  displayCityResults(cities) {
    const { listCity, bodyNP } = this.elements;
    
    this.clearList(listCity);
    
    if (!cities.length) return;

    const cityLinks = cities.map(city => {
      const linkClass = (city.Warehouses === 0 && this.state.deliveryType === 'branch') ? 'd-none' : '';
      const cityData = JSON.parse(this.stripslashes(JSON.stringify(city)));
      
      return `<a data-main="${cityData.MainDescription}" 
                 data-present="${cityData.Present}" 
                 data-ref="${cityData.DeliveryCity}" 
                 class="city-link ${linkClass}" 
                 href="javascript:void(0)">${city.Present}</a>`;
    }).join('');

    listCity.insertAdjacentHTML('afterbegin', cityLinks);
    
    bodyNP?.classList.add('filter-active');
    listCity?.classList.add('active');
    
    this.bindCityLinks();
  }

  bindCityLinks() {
    document.querySelectorAll('a.city-link').forEach(link => {
      link.addEventListener('click', async () => {
        await this.selectCity(link);

      });
    });
  }

  async selectCity(cityLink) {
    const { inputCity, clearCity, bodyNP, cityErrorEl, listCity } = this.elements;
    
    bodyNP?.classList.remove('filter-active');
    if (cityErrorEl) cityErrorEl.innerHTML = '';
    
    clearCity?.classList.remove('d-none');

    if (inputCity) {
      inputCity.readOnly = true;
      inputCity.value = cityLink.getAttribute('data-present');
    }

    const cityData = {
      _delivery_city: cityLink.getAttribute('data-present'),
      _delivery_city_name: cityLink.getAttribute('data-main'),
      _delivery_city_Ref: cityLink.getAttribute('data-ref')
    };

    Object.assign(this.state.properties, cityData);
    await this.updateCartDeliveryAttr(this.state.properties);
    this.elements.inputCity?.setAttribute('data-ref', cityLink.getAttribute('data-ref'));
    this.clearList(listCity);
    this.updateCheckoutButtonState();

    const cityRef = cityLink.getAttribute('data-ref');
    if (this.state.deliveryType === 'branch' && cityRef) {
      await this.loadWarehouses(cityRef);
    } else if (this.state.deliveryType === 'courier' && cityRef) {
      this.bindStreetSearch(cityRef);
    }
  }

  /* Warehouse search and selection for branch delivery */
  async loadWarehouses(cityRef) {
    try {
      const response = await this.requestNovaPoshtaAPI({
        apiKey: NP.NP_API_KEY,
        modelName: "AddressGeneral",
        calledMethod: "getWarehouses",
        methodProperties: {
          CityRef: cityRef,
          Page: "1",
          Limit: "6000",
          Language: "UA"
        }
      });

      if (response?.data) {
        this.data.warehouses = response.data;
        console.log('Loaded warehouses count:', this.data.warehouses.length);
        this.bindWarehouseSearch();
      } else {
        console.warn('No warehouses found for CityRef:', cityRef);
      }
    } catch (error) {
      console.error('Failed to load warehouses:', error);
    }
  }

  bindWarehouseInput() {
    // Placeholder - будет инициализировано после загрузки складов
    console.log('Initializing warehouse input');
    if (this.elements.inputCity?.value.length > 0 && this.elements.inputCity.getAttribute('data-ref')) {
      if (!this.elements.inputWarehouse?.value.length > 0 && this.state.deliveryType === 'branch') {
        console.log('branch city-', this.elements.inputCity?.value);
        console.log('branch ref-', this.elements.inputCity.getAttribute('data-ref'));
        this.loadWarehouses(this.elements.inputCity.getAttribute('data-ref'));
      }      
    }

  }

  bindWarehouseSearch() {
    const { inputWarehouse, clearWarehouse } = this.elements;
    console.log('Binding warehouse search');
    if (!inputWarehouse || !this.data.warehouses) return;

    inputWarehouse.addEventListener('keyup', (event) => {
      if (['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      
      clearWarehouse?.classList.remove('d-none');
      this.searchWarehouses(inputWarehouse.value.trim());
    });
  }

  searchWarehouses(searchTerm) {
    const { listWarehouse, warehouseErrorEl } = this.elements;
    console.log('Searching warehouses for term:', searchTerm);
    console.log('Total warehouses loaded:', this.data.warehouses?.length || 0);
    if (!searchTerm) {
      this.clearList(listWarehouse);
      return;
    }

    const regex = new RegExp(searchTerm, 'i');
    const matchingWarehouses = this.data.warehouses.filter(warehouse => 
      warehouse.Description.search(regex) !== -1
    );

    if (matchingWarehouses.length > 0) {
      this.displayWarehouseResults(matchingWarehouses);
      if (warehouseErrorEl) warehouseErrorEl.innerHTML = '';
    } else {
      if (warehouseErrorEl) warehouseErrorEl.innerHTML = 'Відділення не знайдено';
    }
  }

  displayWarehouseResults(warehouses) {
    const { listWarehouse } = this.elements;
    console.log('Displaying warehouse results, count:', warehouses.length);
    this.clearList(listWarehouse);
    
    const warehouseLinks = warehouses.map(warehouse => 
      `<a class='warehouse-link'style='display:block;' 
          data-val='${this.stripslashes(JSON.stringify(warehouse))}' 
          href='javascript:void(0)'>${warehouse.Description}</a>`
    ).join('');

    listWarehouse.insertAdjacentHTML('afterbegin', warehouseLinks);
    listWarehouse?.classList.add('active');
    
    this.bindWarehouseLinks();
  }

  bindWarehouseLinks() {
    document.querySelectorAll('a.warehouse-link').forEach(link => {
      link.addEventListener('click', async () => {
        await this.selectWarehouse(link);
      });
    });
  }

  async selectWarehouse(warehouseLink) {
    const { inputWarehouse, warehouseErrorEl, listWarehouse } = this.elements;
    
    const warehouseData = JSON.parse(warehouseLink.getAttribute('data-val'));
    
    if (warehouseErrorEl) warehouseErrorEl.innerHTML = '';
    if (inputWarehouse) {
      inputWarehouse.value = warehouseData.Description;
      inputWarehouse.readOnly = true;
    }

    const deliveryData = {
      _delivery_warehouse: warehouseData.Description,
      _delivery_warehouse_zip: '00000',
      _delivery_warehouse_name: `${this.pointPrefix(warehouseData.CategoryOfWarehouse)}:${warehouseData.Number}`,
      _delivery_warehouse_address: warehouseData.ShortAddress,
      _delivery_warehouse_CityRef: warehouseData.CityRef,
      _delivery_warehouse_Number: warehouseData.Number,
      _delivery_warehouse_Ref: warehouseData.Ref,
      _delivery_warehouse_SettlementRef: warehouseData.SettlementRef,
      _delivery_warehouse_TypeOfWarehouse: warehouseData.TypeOfWarehouse
    };

    Object.assign(this.state.properties, deliveryData);
    await this.updateCartDeliveryAttr(this.state.properties);
    this.clearList(listWarehouse);
    this.updateCheckoutButtonState();
  }


/* Street search and selection for courier delivery */
  bindStreetInput() {
    // Placeholder - будет инициализировано при выборе города для курьерской доставки
    console.log('Initializing street input');
    if (this.elements.inputCity?.value.length > 0 && this.elements.inputCity.getAttribute('data-ref')) {
      
      if (!this.elements.inputStreet?.value.length > 0 && this.state.deliveryType === 'courier') {
        console.log('courier city-', this.elements.inputCity?.value);
        console.log('courier ref-', this.elements.inputCity.getAttribute('data-ref'));
        this.bindStreetSearch(this.elements.inputCity.getAttribute('data-ref'))
      }
      
    }
  }

  bindStreetSearch(cityRef) {
    const { inputStreet, clearStreet } = this.elements;
    if (!inputStreet) return;

    inputStreet.addEventListener('keyup', (event) => {
      if (['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      
      clearStreet?.classList.remove('d-none');
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.handleStreetSearch(inputStreet.value.trim(), cityRef);
      }, 500);
    });
  }

  async handleStreetSearch(searchTerm, cityRef) {
    if (!searchTerm) return;

    try {
      const response = await this.requestNovaPoshtaAPI({
        apiKey: NP.NP_API_KEY,
        modelName: "Address",
        calledMethod: "getStreet",
        methodProperties: {
          CityRef: cityRef,
          FindByString: searchTerm,
          Page: "1",
          Limit: ""
        }
      });

      if (response?.data) {
        this.displayStreetResults(response.data);
      }
    } catch (error) {
      console.error('Street search error:', error);
    }
  }

  displayStreetResults(streets) {
    const listStreet = document.querySelector('#street_filter');
    if (!listStreet) return;
    
    this.clearList(listStreet);
    
    const streetLinks = streets.map(street => 
      `<a data-ref="${street.Ref}" 
          data-street="${street.StreetsType}${street.Description}" 
          data-prefix="${street.StreetsType}" 
          class="street-link" 
          href="javascript:void(0)">${street.StreetsType}${street.Description}</a>`
    ).join('');

    listStreet.insertAdjacentHTML('afterbegin', streetLinks);
    listStreet.classList.add('active');
    
    this.bindStreetLinks();
  }

  bindStreetLinks() {
    document.querySelectorAll('a.street-link').forEach(link => {
      link.addEventListener('click', async () => {
        await this.selectStreet(link);
      });
    });
  }

  async selectStreet(streetLink) {
    const { inputStreet } = this.elements;
    const listStreet = document.querySelector('#street_filter');
    
    const streetData = {
      _delivery_courier_address: streetLink.getAttribute('data-street'),
      _delivery_courier_street: streetLink.getAttribute('data-street'),
      _delivery_street_Ref: streetLink.getAttribute('data-ref')
    };

    if (inputStreet) {
      inputStreet.value = streetLink.getAttribute('data-street');
    }

    Object.assign(this.state.properties, streetData);
    await this.updateCartDeliveryAttr(this.state.properties);
    this.clearList(listStreet);
    this.updateCheckoutButtonState();
  }

  bindAddressInputs() {
    const { inputBuild, inputFlat } = this.elements;
    
    inputBuild?.addEventListener('focusout', async () => {
      if (inputBuild.value) {
        const buildingSuffix = `, буд.${inputBuild.value}`;
        this.state.properties._delivery_courier_house = buildingSuffix;
        this.state.properties._delivery_courier_address += buildingSuffix;
        await this.updateCartDeliveryAttr(this.state.properties);
      }
    });

    inputFlat?.addEventListener('focusout', async () => {
      if (inputFlat.value) {
        const flatSuffix = `, кв.${inputFlat.value}`;
        this.state.properties._delivery_courier_flat = flatSuffix;
        this.state.properties._delivery_courier_address += flatSuffix;
        await this.updateCartDeliveryAttr(this.state.properties);
      }
    });
  }

  bindCheckoutButton() {
    const { checkoutButton } = this.elements;
    if (!checkoutButton) return;

    checkoutButton.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      checkoutButton.disabled = true;
      checkoutButton.classList.add('disabled');
      
      setTimeout(async () => {
        await this.handleCheckout();
      }, 200);
    });
  }

  async handleCheckout() {
    try {
      const cartData = await fetch(`${NP.cartUrl}.json`).then(res => res.json());
      
      const address = {
        first_name: ' ',
        last_name: ' ',
        address1: this.state.deliveryType === 'branch' 
          ? this.state.properties._delivery_warehouse 
          : `${this.state.properties._delivery_courier_address} (${NP.methodCourier})`,
        zip: '00000',
        city: this.state.properties._delivery_city_name || this.state.properties._delivery_city,
        country: this.config.country
      };

      const path = cartData.items.map(item => `${item.variant_id}:${item.quantity}`).join(',');
      
      const params = [];
      
      // Add properties
      Object.entries(this.state.properties).forEach(([key, value]) => {
        if (value) params.push(`attributes[${key}]=${encodeURIComponent(value)}`);
      });
      
      // Add address
      Object.entries(address).forEach(([key, value]) => {
        if (value) params.push(`checkout[shipping_address][${key}]=${encodeURIComponent(value)}`);
      });
      
      if (cartData.note) {
        params.push(`note=${encodeURIComponent(cartData.note)}`);
      }
      
      const url = `${NP.cartUrl}/${path}?${params.join('&')}`;
      window.location.href = url;
      
    } catch (error) {
      console.error('Checkout error:', error);
      // Re-enable button on error
      const { checkoutButton } = this.elements;
      if (checkoutButton) {
        checkoutButton.disabled = false;
        checkoutButton.classList.remove('disabled');
      }
    }
  }

  initSearch() {
    if (!this.elements) {
      console.warn('NovaPoshtaAPI elements is null, skipping initSearch');
      return;
    }
    console.log('Initializing quick city links');
    // Initialize quick city links
    document.querySelectorAll('a.quick-city-link').forEach(cityLink => {
      cityLink.addEventListener('click', async () => {        
        let inputs = document.querySelectorAll('.form-group input');
        inputs.forEach((input) => {
          if (input) {
            input.value = '';
            input.readOnly = false;
            input.focus();
          }
        });
        await this.updateCartDeliveryAttr(this.state.clearProperties.all);
        await this.selectCity(cityLink);
      });
    });
  }  

  clearAllInputs() {
    this.elements.inputFields?.forEach(input => {
      input.value = '';
      input.readOnly = false;
    });
    
    document.querySelectorAll('.clear').forEach(clear => {
      clear.classList.add('d-none');
    });
  }

  clearAllFilters() {
    this.elements.filterFields?.forEach(filter => {
      this.clearList(filter);
    });
  }

  clearErrors() {
    [this.elements.cityErrorEl, this.elements.warehouseErrorEl, this.elements.streetErrorEl]
      .forEach(errorEl => {
        if (errorEl) errorEl.innerHTML = '';
      });
  }

  clearList(filter) {
    if (!filter) return;
    while (filter.firstChild) {
      filter.removeChild(filter.firstChild);
    }
  }

  pointPrefix(data) {
    const prefixMap = {
      'Postomat': 'Поштомат',
      'Branch': 'Відділення'
    };
    return prefixMap[data] || data;
  }

  stripslashes(str) {
    return str.replace(/'/g, 'ʹ');
  }

  handleError(code) {
    console.error('Nova Poshta Error:', code);
  }

  destroy() {
    // Спочатку очищаємо стан
    this.cleanup();
    
    // Очищуємо event listeners шляхом клонування елементів, тільки якщо елементи існують
    if (this.elements) {
      const elementsToClean = [
        ...(this.elements.deliveryTypes || []),
        this.elements.inputCity,
        this.elements.inputWarehouse,
        this.elements.inputStreet,
        this.elements.inputBuild,
        this.elements.inputFlat,
        this.elements.checkoutButton,
        this.elements.clearCity,
        this.elements.clearWarehouse,
        this.elements.clearStreet
      ].filter(Boolean);

      elementsToClean.forEach(element => {
        if (element && element.parentNode) {
          try {
            const newElement = element.cloneNode(true);
            element.parentNode.replaceChild(newElement, element);
          } catch (error) {
            console.warn('Failed to clean element:', error);
          }
        }
      });

      // Очищаємо динамічно створені елементи (посилання в dropdown'ах)
      [this.elements.listCity, this.elements.listWarehouse].forEach(list => {
        if (list) {
          const links = list.querySelectorAll('a');
          links.forEach(link => {
            if (link.parentNode) {
              try {
                const newLink = link.cloneNode(true);
                link.parentNode.replaceChild(newLink, link);
              } catch (error) {
                console.warn('Failed to clean link:', error);
              }
            }
          });
        }
      });
    }

    // Очищаємо посилання на об'єкти
    this.elements = null;
    this.state = null;
    this.data = null;
    this.config = null;
    
    console.log('NovaPoshtaAPI destroyed');
  }
}

// Initialize Nova Poshta API
//function NovaPoshtaMain() {
  //new NovaPoshtaAPI();
//}

// Auto-initialize when called
//NovaPoshtaMain();